class InternalCacheElement {
    created: number
    constructor(public key: string, public value: any, public maxage: number = 1000) {
        this.created = Date.now()
    }
    stale() {
        return Date.now() - this.created - this.maxage > 0
    }
}
type InternalCacheType = {
    [key: string]: InternalCacheElement
}
class ValidationCache {
    _internalCache: InternalCacheType = {}
    constructor(public cacheName: string, public defaultMaxage: number = 10000) {}
    setName(newName: string) {
        if(this.cacheName !== newName) {
            this.clear()
            this.cacheName = newName
        }
    }
    getItem(key: string) {
        const o = this._internalCache[key]
        if (o) {
            if (o.stale()) {
                delete this._internalCache[key]
                return undefined
            }
            return o
        } else {
            return undefined
        }
    }
    get(key: string) {
        const o = this.getItem(key)
        if (o) { return o.value }
        return undefined
    }
    put(key: string, value: any, maxage: number = this.defaultMaxage) {
        const elem = new InternalCacheElement(key, value, maxage)
        this._internalCache[key] = elem
    }
    clear() {
        this._internalCache = {}
    }
    elements() {
        return Object.keys(this._internalCache).map(k => this._internalCache[k])
    }
    purge() {
        const staleObjects = this.elements().filter(el => el.stale())
        for(let so of staleObjects) {
            delete this._internalCache[so.key]
        }
    }
}

export default ValidationCache